<svelte:options tag='agz-menu-apps' />
<script>
  import {apps, financialUrl} from './MenuApps.data';
  import {clickOutside} from './clickoutside';

  export let current = 'contabil';
  export let visible = false;
  export let list = false;
  export let legacy = false;
  export let show_financial_link = false;

  $: allApps = show_financial_link === "true" ? [financialUrl, ...apps] : apps;
  $: currentApp = allApps.find((app) => app.slugName === current);
  $: appsFiltered = allApps.filter((app) => app.slugName !== current);

  function handleClickOutside() {
    visible = false;
  }
</script>

<div id='menu-apps' class:menu-apps-list={list}>
  {#if !list}
    <button class:visible class:is-legacy={legacy} class='menuappsbutton' on:click|stopPropagation={() => (visible = !visible)}>
      <div class='menu-apps-svg-container'>{@html currentApp?.icon}</div>
      <div class='menu-apps-button-title'>{currentApp?.title}</div>
      <div class='menu-apps-arrow'>
        <svg width='11' height='7' viewBox='0 0 11 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M10.6852 0.319797C10.2907 -0.106599 9.69885 -0.106599 9.30432 0.319797L5.49053 4.44162L1.67675 0.319797C1.28222 -0.106599 0.690427 -0.106599 0.295897 0.319797C-0.0986324 0.746193 -0.0986324 1.38579 0.295897 1.81218L4.83298 6.71574C5.03025 6.92893 5.29327 7 5.55629 7C5.81931 7 6.08233 6.92893 6.27959 6.71574L10.8167 1.81218C11.0797 1.45685 11.0797 0.746193 10.6852 0.319797Z'
            fill='rgb(202, 200, 210)'
          />
        </svg>
      </div>
    </button>
  {/if}

  <ul
    class='menuAppsDropdowndown'
    class:visible
    class:menuAppsDropdowndownlist={list}
    use:clickOutside={{
      enabled: visible,
      cb: () => {
        handleClickOutside();
      },
    }}
  >
    {#each appsFiltered as app}
      {#if app.slugName !== 'apps'}
        <li class='menuAppsDropdowndownitem' class:menuAppsDropdowndownitemlist={list}>
          <a class="{app.beta ? 'menu-apps-link beta' : 'menu-apps-link'}" href={app.link}>
            <div class='menu-apps-svg-container'>{@html app.icon}</div>
            {app.title}
          </a>
        </li>
      {/if}
    {/each}
  </ul>
</div>

<style>
    :host {
        display: flex;
    }

    div#menu-apps {
        position: relative;
        padding: 0;
        margin: 0;
        font-family: Inter, sans-serif;
    }

    .menu-apps-list {
        width: 100%;
    }

    .menuAppsDropdowndown {
        position: absolute;
        top: 100%;
        width: auto;
        min-width: calc(100% - 16px);
        left: 0;
        margin: 0;
        padding: 8px;
        list-style: none;
        border-radius: 8px;
        background-color: rgb(255, 255, 255);
        box-shadow: rgb(122 115 136 / 30%) 0px 2px 4px;
        overflow-y: auto;
        z-index: 4;
        display: none;
    }

    .menuAppsDropdowndown.visible {
        display: block;
    }

    .menuAppsDropdowndownlist {
        position: relative;
        top: 0;
        padding: 0;
        display: block;
        box-shadow: none;
    }

    .menuAppsDropdowndownitem {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        text-decoration: none;
        border-radius: 8px;
        border: 1px solid transparent;
        cursor: pointer;
        transition: background 100ms linear 0s, border 100ms linear 0s;
        font-family: Inter, sans-serif;
    }

    .menuAppsDropdowndownitemlist {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        font-size: 16px;
        color: rgb(65, 58, 79);
        border-radius: 8px;
        border: 1px solid rgb(233, 231, 239);
        cursor: pointer;
        transition: background 100ms linear 0s, border 100ms linear 0s;
        margin-top: 8px;
    }

    .menuAppsDropdowndownitem:hover {
        background-color: rgb(251, 248, 255);
        border-color: rgb(182, 155, 224);
    }

    .menu-apps-svg-container {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        width: 40px;
        margin-right: 8px;
        color: rgb(65, 58, 79);
    }

    .menu-apps-link {
        width: 100%;
        color: rgb(65, 58, 79);
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        font-size: 14px;
        padding: 14px 16px 14px 0px;
        text-decoration: none;
        border-radius: 8px;
        border: 1px solid transparent;
        cursor: pointer;
        transition: background 100ms linear 0s, border 100ms linear 0s;
        white-space: nowrap;
        font-family: Inter, sans-serif;
        font-weight: normal;
    }

    .menu-apps-link.beta:after {
       content: "BETA";
       margin-left: 6px;
       margin-bottom: 5px;
       font-size: 10px;
       font-weight: 600;
       letter-spacing: 0.1rem;
       color: #7A4DBF;
    }

    .menuappsbutton {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        font-family: Inter, sans-serif;
        font-weight: 400;
        border-radius: 8px;
        border: none;
        outline: none;
        transition: background-color 250ms ease 0s, box-shadow 250ms ease 0s, background 500ms ease 0s, color 500ms ease 0s, fill 500ms ease-out 0s;
        background-position: center center;
        font-size: 14px;
        padding: 12px;
        color: rgb(65, 58, 79);
        background-color: unset;
        cursor: pointer;
    }

    .menuappsbutton:hover {
        background-color: rgb(233, 231, 239);
    }

    .menuappsbutton.visible {
        background-color: rgb(233, 231, 239);
    }

    .menuappsbutton.is-legacy {
        border: 1px solid #E9E7EF;
        height: 37px;
    }

    .menu-apps-button-title {
        padding-right: 28px;
        max-width: 160px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-family: Inter, sans-serif;
    }

    .menu-apps-arrow {
        transition: transform 0.2s ease-in-out 0s;
        transform-origin: center;
    }

    .menu-apps-arrow svg {
        display: block;
    }

    .menuappsbutton.visible > .menu-apps-arrow {
        transform: scale(-1);
    }
</style>
